import firebase from 'firebase';
import 'firebase/auth';

const config = {
    apiKey: "AIzaSyCN_4lB6eOHnPmCip7Wpb4yjmjfO3sQMr8",
    authDomain: "react-219608.firebaseapp.com",
    databaseURL: "https://react-219608.firebaseio.com",
    projectId: "react-219608",
    storageBucket: "react-219608.appspot.com",
    messagingSenderId: "1003532086068"
  };

export const fire= firebase.initializeApp(config);

firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

export const db = firebase.database();

